/* eslint-disable */
export enum UserRol
{
    Administrator = "Administrador",
    Buyer = "Comprador",
    Seller = "Vendedor",
}
